import React from 'react';
import {Route} from 'react-router-dom';

import * as Screens from './screens';

const routes = [
    <Route
        exact
        path="/administration/data-items"
        component={Screens.List}
        key="data-items"
    />,
    <Route
        exact
        path="/administration/data-items/:id/edit"
        component={Screens.Edit}
        key="data-items-edit"
    />,
];

export default routes;
